import {
  activateDevice
} from "./chunk-656IUB4B.mjs";

// src/hooks/wbk/devices/activate.ts
import { useMutation } from "@tanstack/react-query";
var useActivateDevice = () => {
  return useMutation({
    mutationFn: activateDevice
  });
};

export {
  useActivateDevice
};
//# sourceMappingURL=chunk-XUVF4QVE.mjs.map